var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProffesionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    rx: 5,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1993 13.4997C15.1165 13.4997 16.6757 12.0422 16.6757 10.2499C16.6757 8.45756 15.1165 7 13.1993 7C11.282 7 9.7228 8.45756 9.7228 10.2499C9.7228 12.0422 11.282 13.4997 13.1993 13.4997ZM13.1993 8.62493C14.1576 8.62493 14.9375 9.35399 14.9375 10.2499C14.9375 11.1457 14.1576 11.8748 13.1993 11.8748C12.2409 11.8748 11.461 11.1457 11.461 10.2499C11.461 9.35399 12.2409 8.62493 13.1993 8.62493ZM18.3977 19.1334C18.4296 19.5813 18.1248 19.9995 17.5292 19.9995C17.0755 19.9995 16.6937 19.6701 16.663 19.2406C16.5674 17.8827 15.576 16.7615 14.2532 16.3645L13.7062 17.132L14.3395 19.2932C14.4456 19.6539 14.1049 20 13.6437 20H12.756C12.2948 20 11.9547 19.6539 12.0601 19.2932L12.6934 17.132L12.1465 16.3645C10.8231 16.7615 9.83231 17.8827 9.73613 19.2412C9.70426 19.6886 9.29172 20.0298 8.81139 19.9978C8.33222 19.968 7.97008 19.5813 8.00195 19.1334C8.18215 16.5822 10.4656 14.583 13.1998 14.583C15.9341 14.583 18.217 16.5817 18.3977 19.1334Z",
    fill: "#09041C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProffesionalIcon);
export default __webpack_public_path__ + "static/media/proffesional-icon.6d90004ad0b605b8380bf047156fdfe5.svg";
export { ForwardRef as ReactComponent };